import React from 'react';
import { Navigate } from 'react-router-dom';

import DashboardLayout from 'src/shared/ui/layouts/DashboardLayout';
import MainLayout from 'src/shared/ui/layouts/MainLayout';

import AccountView from 'src/account/AccountView';
import CustomerListView from 'src/customer/ui/views/CustomerListView';
import CustomerFormView from 'src/customer/ui/views/CustomerFormView';
import HeadquarterContractListView from 'src/contract/ui/views/HeadquarterContractListView';
import ContractFormView from 'src/contract/ui/views/ContractFormView';
import DashboardView from 'src/reports/DashboardView';
import LoginView from 'src/auth/ui/views/LoginView';
import LogoutView from 'src/auth/ui/views/LogoutView';
import NotFoundView from 'src/shared/ui/views/NotFoundView';
import ContractTypeListView from 'src/contract-type/ui/views/ContractTypeListView';
import ContractTypeFormView from 'src/contract-type/ui/views/ContractTypeFormView';
import ProductTypeListView from 'src/product-type/ui/views/ProductTypeListView';
import ProductTypeFormView from 'src/product-type/ui/views/ProductTypeFormView';
import InventoryListView from 'src/inventory/ui/views/InventoryListView';
import InventoryFormView from 'src/inventory/ui/views/InventoryFormView';
import StampListView from 'src/stamp/ui/views/StampListView';
import StampFormView from 'src/stamp/ui/views/StampFormView';
import TermListView from 'src/term/ui/views/TermListView';
import BillingView from 'src/billing/ui/views/BillingView';
import InvoiceFormView from 'src/billing/ui/views/InvoiceFormView';
import PaymentListView from 'src/payment/ui/views/PaymentListView';
import PaymentFormView from 'src/payment/ui/views/PaymentFormView';
import ConversationListView from 'src/conversation/ui/views/ConversationListView';
import EmployeeListView from 'src/employee/ui/views/EmployeeListView';
import EmployeeFormView from 'src/employee/ui/views/EmployeeFormView';
import RegisterView from 'src/auth/ui/views/RegisterView';
import SettingsView from 'src/settings/SettingsView';
import ActivityListView from 'src/activity/ui/views/ActivityListView';
import DailyCashClosureListView from 'src/daily-cash-closure/ui/views/DailyCashClosureListView';
import DailyCashClosureFormView from 'src/daily-cash-closure/ui/views/DailyCashClosureFormView';

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'account', element: <AccountView /> },
      { path: 'customers', element: <CustomerListView /> },
      {
        path: 'customers/:customerId',
        element: <CustomerFormView />
      },
      { path: 'contracts', element: <HeadquarterContractListView /> },
      {
        path: 'contracts/:contractId',
        element: <ContractFormView />
      },
      { path: 'contract-types', element: <ContractTypeListView /> },
      {
        path: 'contract-types/:contractTypeId',
        element: <ContractTypeFormView />
      },
      { path: 'product-types', element: <ProductTypeListView /> },
      {
        path: 'product-types/:productTypeId',
        element: <ProductTypeFormView />
      },
      { path: 'inventory', element: <InventoryListView /> },
      {
        path: 'inventory/:inventoryId',
        element: <InventoryFormView />
      },
      { path: 'terms', element: <TermListView /> },
      { path: 'billing', element: <BillingView /> },
      {
        path: 'billing/:invoiceId',
        element: <InvoiceFormView />
      },
      { path: 'payments', element: <PaymentListView /> },
      {
        path: 'payments/:paymentId',
        element: <PaymentFormView />
      },
      { path: 'stamps', element: <StampListView /> },
      {
        path: 'stamps/:stampId',
        element: <StampFormView />
      },
      { path: 'employees', element: <EmployeeListView /> },
      {
        path: 'employees/:employeeId',
        element: <EmployeeFormView />
      },
      {
        path: 'daily-cash-closures',
        element: <DailyCashClosureListView />
      },
      {
        path: 'daily-cash-closures/:dailyCashClosureId',
        element: <DailyCashClosureFormView />
      },
      { path: 'conversations', element: <ConversationListView /> },
      { path: 'reports', element: <DashboardView /> },
      { path: 'dashboard', element: <DashboardView /> },
      { path: 'activity', element: <ActivityListView /> },
      { path: 'settings', element: <SettingsView /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <LoginView /> },
      { path: 'logout', element: <LogoutView /> },
      { path: 'register', element: <RegisterView /> },
      { path: '404', element: <NotFoundView /> },
      { path: '/', element: <Navigate to="/app/customers" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
